import React from "react";
import styles from "./VoucherConditionComments.module.scss";
import {IProduct} from 'data/interfaces/products';
import SellerComments from 'gui/pages/mainRouter/pages/ad/components/commons/sellerComments';
import moment from 'moment';
import {createSelector} from "redux-starter-kit";
import {IDetailProps} from "../../../../../commons/sellerComments/components/detail/Detail";

export interface IVoucherConditionCommentsProps {
  className?: string;
  product: IProduct;
  modifyDetails?: (details: IDetailProps[]) => IDetailProps[];
}

const descriptionSelector = createSelector(['product.voucherDetails.conditions']);
const expirationSelector = createSelector(['product.voucherDetails.expiration'], expiration => {
  if (expiration) {
    return moment(expiration).format('MMM D YYYY');
  } else {
    return '';
  }
});

const VoucherConditionComments = (props: IVoucherConditionCommentsProps) => <SellerComments
  title="מימוש השובר"
  description={descriptionSelector(props)}
  className={props.className}
  mustLoadDescription
  iconContainerClassName={styles.VoucherConditionComments}
  details={props.modifyDetails([
    {
      title: "בתוקף עד",
      value: expirationSelector(props),
    }
  ])}
/>;

VoucherConditionComments.defaultProps = {
  product: {voucherDetails: {}},
  modifyDetails: d => d,
};

export default VoucherConditionComments;
